import { Box, Breadcrumbs, Button, Card, CardContent, Grid, Modal, TextField, Typography } from "@mui/material";
import axios from "axios";
import React, { useState } from "react";
import { MdNavigateNext } from "react-icons/md";
import { Link, useNavigate, useParams } from "react-router-dom";
import { GET_GST } from "../../constant/endpoint";
import { isEmpty } from "lodash";
import Swal from "sweetalert2";
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    height: '22%',
    transform: 'translate(-50%, -50%)',
    width: 300,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    padding: '0px 30px',
    overflow: "auto",
    paddingBottom: "20px",
    borderRadius:"20px"
};


const GST = () => {
    const [open, setOpen] = useState(true)
    const [password, setPassword] = useState(undefined)
    const [dataList, setDataList] = useState({})
    const { match_id } = useParams()
    const navigate = useNavigate()
    const breadcrumbs = [
        <Link underline="hover" key="1" color="inherit" to={'/match_data'} >
            <h4>Match Data</h4>
        </Link>, <Link
            underline="hover"
            color="inherit"
        >
            Match Data
        </Link>
    ];
    const handleClose = () => {
        return navigate('/match_data')
    };
    const getSweetAlert = (type, topic) => {
        Swal.fire({
            position: 'top-end',
            icon: type,
            title: topic,
            showConfirmButton: false,
            timer: 3000
        })
    }
    const submit = async () => {
        const data = {
            password: password,
            match_id: Number(match_id)
        }
        if(!isEmpty(password)){
            const response = await axios.post(GET_GST.replace(':match_id', match_id), data)
            if (response?.data?.status === 'success') {
                setDataList(response?.data?.data)
                setOpen(false)
            }
        }else{
            getSweetAlert('error','Please field Password')
        }
    }
    console.log(dataList)
    return (
        <>
            <div className="homeCard">
                <div className='subHomeCard'>
                    {
                        !isEmpty(dataList) &&
                        <Breadcrumbs
                            separator={<MdNavigateNext fontSize="small" />}
                            aria-label="breadcrumb"
                        >

                            {breadcrumbs}
                        </Breadcrumbs>
                    }
                    <Grid container item spacing={4} >
                        {
                            dataList?.pollGSTData?.map((item) =>
                                <Grid xs={3} item>
                                    <Card sx={{ minWidth: 275 }}>
                                        <CardContent>
                                            <h3 style={{ textAlign: "center" }}>Polls</h3>
                                            <hr></hr>
                                            <div style={{ display: 'flex', justifyContent: "space-between" }}>
                                                <h4>Total Slots</h4>
                                                <p>{item?.totalSlots}</p>
                                            </div>
                                            <div style={{ display: 'flex', justifyContent: "space-between" }}>
                                                <h4>Total Cash</h4>
                                                <p>{item?.totalCash}</p>
                                            </div>
                                            <div style={{ display: 'flex', justifyContent: "space-between" }}>
                                                <h4>Total Wining</h4>
                                                <p>{item?.totalWining}</p>
                                            </div>
                                            <div style={{ display: 'flex', justifyContent: "space-between" }}>
                                                <h4>Total Win Reward</h4>
                                                <p>{item?.winReward}</p>
                                            </div>
                                            <div style={{ display: 'flex', justifyContent: "space-between" }}>
                                                <h4>Profit</h4>
                                                <p>{item?.profit}</p>
                                            </div>
                                            <div style={{ display: 'flex', justifyContent: "space-between" }}>
                                                <h4>Total Prediction Cancelled</h4>
                                                <p>{item?.predictionCancelled}</p>
                                            </div>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            )
                        }
                        {
                            dataList?.opinionProGSTData?.map((item) =>
                                <Grid xs={3} item>
                                    <Card sx={{ minWidth: 275 }}>
                                        <CardContent>
                                            <h3 style={{ textAlign: "center" }}>Opinion Pro</h3 >
                                            <hr></hr>
                                            <div style={{ display: 'flex', justifyContent: "space-between" }}>
                                                <h4>Total Slots</h4>
                                                <p>{item?.totalSlots}</p>
                                            </div>
                                            <div style={{ display: 'flex', justifyContent: "space-between" }}>
                                                <h4>Total Cash</h4>
                                                <p>{item?.totalCash}</p>
                                            </div>
                                            <div style={{ display: 'flex', justifyContent: "space-between" }}>
                                                <h4>Total Wining</h4>
                                                <p>{item?.totalWining}</p>
                                            </div>
                                            <div style={{ display: 'flex', justifyContent: "space-between" }}>
                                                <h4>Total Win Reward</h4>
                                                <p>{item?.winReward}</p>
                                            </div>
                                            <div style={{ display: 'flex', justifyContent: "space-between" }}>
                                                <h4>Profit</h4>
                                                <p>{item?.profit}</p>
                                            </div>
                                            <div style={{ display: 'flex', justifyContent: "space-between" }}>
                                                <h4>Total Prediction Cancelled</h4>
                                                <p>{item?.predictionCancelled}</p>
                                            </div>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            )
                        }
                        {
                            dataList?.inPlayGSTData?.map((item) =>
                                <Grid xs={3} item>
                                    <Card sx={{ minWidth: 275 }}>
                                        <CardContent>
                                            <h3 style={{ textAlign: "center" }}>QUIZ PLAY</h3>
                                            <hr></hr>
                                            <div style={{ display: 'flex', justifyContent: "space-between" }}>
                                                <h4>Total Slots</h4>
                                                <p>{item?.totalSlots}</p>
                                            </div>
                                            <div style={{ display: 'flex', justifyContent: "space-between" }}>
                                                <h4>Total Cash</h4>
                                                <p>{item?.totalCash}</p>
                                            </div>
                                            <div style={{ display: 'flex', justifyContent: "space-between" }}>
                                                <h4>Total Wining</h4>
                                                <p>{item?.totalWining}</p>
                                            </div>
                                            <div style={{ display: 'flex', justifyContent: "space-between" }}>
                                                <h4>Total Win Reward</h4>
                                                <p>{item?.winReward}</p>
                                            </div>
                                            <div style={{ display: 'flex', justifyContent: "space-between" }}>
                                                <h4>Profit</h4>
                                                <p>{item?.profit}</p>
                                            </div>
                                            <div style={{ display: 'flex', justifyContent: "space-between" }}>
                                                <h4>Total Prediction Cancelled</h4>
                                                <p>{item?.predictionCancelled}</p>
                                            </div>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            )
                        }
                        {
                            dataList?.tradingGSTData?.map((item) =>
                                <Grid xs={3} item>
                                    <Card sx={{ minWidth: 275 }}>
                                        <CardContent>
                                            <h3 style={{ textAlign: "center" }}>Trading</h3>
                                            <hr></hr>
                                            <div style={{ display: 'flex', justifyContent: "space-between" }}>
                                                <h4>Total Slots</h4>
                                                <p>{item?.totalSlots}</p>
                                            </div>
                                            <div style={{ display: 'flex', justifyContent: "space-between" }}>
                                                <h4>Total Incoming</h4>
                                                <p>{item?.totalWining + item?.totalCash + item?.saleAdminComssionAmount}</p>
                                            </div>
                                            {/* <div style={{ display: 'flex', justifyContent: "space-between" }}>
                                                <h4>Total Cash</h4>
                                                <p>{item?.totalCash}</p>
                                            </div> */}
                                            <div style={{ display: 'flex', justifyContent: "space-between" }}>
                                                <h4>Total Outgoing</h4>
                                                <p>{item?.refundCashAmount + item?.refundWinAmount + item?.winReward + item?.soldSlotsRewards}</p>
                                            </div>
                                            <div style={{ display: 'flex', justifyContent: "space-between" }}>
                                                <h4>Profit</h4>
                                                <p>{item?.profit}</p>
                                            </div>
                                            <div style={{ display: 'flex', justifyContent: "space-between" }}>
                                                <h4>Prediction Cancelled</h4>
                                                <p>{item?.predictionCancelled}</p>
                                            </div>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            )
                        }
                    </Grid>
                </div>
            </div>
            <Modal
                open={open}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                onBackdropClick={() => setOpen(true)}
                style={{backgroundColor:"#fff"}}
            >
                <Box sx={style} spacing={0.5} direction="row" useFlexGap flexWrap="wrap">
                    <Grid container spacing={1}>
                        <Grid xs={12} item style={{ marginTop: "30px" }}>
                            <label><strong>Password for Match Data</strong></label><br></br>
                            <TextField Required style={{ width: "100%" }} id="outlined-basic" type='password' size={'small'} variant="outlined" name={'password'} onChange={(e) => setPassword(e.target.value)}/>
                        </Grid>
                        <Grid xs={9} mt={2}>
                            <Button style={{backgroundColor: '#f57c00', color: '#FFFFFF'}} onClick={handleClose} variant="contained">Cancel</Button>
                        </Grid>
                        <Grid xs={3} mt={2} textAlign={'right'}>
                            <Button onClick={submit} variant="contained" >Submit</Button>
                        </Grid>
                    </Grid>
                </Box>
            </Modal>
        </>
    )
}


export default GST